import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Observable } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';

import {
  UpdateQueueETagAction,
  actionAndETagUpdate$,
} from '®shared/container-structure/edit/queue';
import { getETagFromError, getETagFromMetaData } from '®shared/tarl-v3-jsonapi';

import { ReadingListMetadataService } from '../metadata';

import {
  ListOwnersEditorActionTypes,
  ListOwnersEditorSaveAction,
  ListOwnersEditorSaveFailedAction,
  ListOwnersEditorSaveSucceededAction,
} from './list-owners-editor.actions';

@Injectable()
export class ListOwnersEditorEffects {
  saveListOwners$: Observable<
    | ListOwnersEditorSaveSucceededAction
    | ListOwnersEditorSaveFailedAction
    | UpdateQueueETagAction
  > = createEffect(() =>
    this.actions$.pipe(
      ofType(ListOwnersEditorActionTypes.LIST_OWNERS_EDITOR_SAVE),
      switchMap((action: ListOwnersEditorSaveAction) => {
        const { listId, ownersWithPublisherFlags } = action.payload;
        return this.readingListMetadataService
          .assignListOwnersAndPublishers(listId, ownersWithPublisherFlags)
          .pipe(
            switchMap(metadata =>
              actionAndETagUpdate$(
                new ListOwnersEditorSaveSucceededAction(action.payload),
                getETagFromMetaData(metadata),
              ),
            ),
            catchError(error =>
              actionAndETagUpdate$(
                new ListOwnersEditorSaveFailedAction({
                  ...action.payload,
                  error,
                }),
                getETagFromError(error),
              ),
            ),
          );
      }),
    ),
  );

  constructor(
    private actions$: Actions,
    private readingListMetadataService: ReadingListMetadataService,
  ) {}
}
